import { useNavigate } from 'react-router-dom';
import secureImg from "@illustrations/secure-400x284.png";
import { Button } from '@common';

const ResetPasswordSuccess = () => {

    const navigate = useNavigate();

    return (
        <div className="flex flex-col w-full items-center text-center">
            <div className="flex justify-center items-center h-[200px] mb-4">
                <img src={secureImg} alt="Illustration of a laptop with a lock displayed on its screen, representing a secure password" className="w-[200px]" />
            </div>
            <h1 className="text-base leading-6 font-medium text-neutral-950 tracking-[0.16px] mb-6 md:mb-8">
                Your Password Has Been Reset
            </h1>
            <Button
                variant="primary"
                size="lg"
                className="w-full"
                onClick={() => navigate(`/`)}
            >
                Go to Dashboard
            </Button>
        </div>
    );
};

export default ResetPasswordSuccess;

